// src/mixins/reports.js
export default {
    methods: {
        cleanData(data) {
            return data.map(row => {
            const newRow = {};
            for (const key in row) {
                if (key === "sections" && Array.isArray(row.sections)) {
                newRow.sections = row.sections.map(section => {
                    const cleanSection = {};
                    for (const secKey in section) {
                    cleanSection[secKey] = (section[secKey] === null || section[secKey] === undefined) ? "" : section[secKey];
                    }
                    return cleanSection;
                });
                } else {
                newRow[key] = (row[key] === null || row[key] === undefined) ? "" : row[key];
                }
            }
            return newRow;
            });
        },
        downloadAsPDFFromMixin(tabulatorRef = 'tabulator', dataKey = 'tabulatorData') {
            const tabulatorInstance = this.$refs[tabulatorRef].getInstance();
            const cleanData = this.cleanData(this[dataKey]);
            tabulatorInstance.replaceData(cleanData);
            setTimeout(() => tabulatorInstance.downloadToTab("pdf"), 500);
        },
        downloadAsCSVFromMixin(tabulatorRef = 'tabulator', dataKey = 'tabulatorData') {
            const tabulatorInstance = this.$refs[tabulatorRef].getInstance();
            const cleanData = this.cleanData(this[dataKey]);
            tabulatorInstance.replaceData(cleanData);
            tabulatorInstance.download("csv", "data.csv", {
                delimiter: ",",
            });
        }
    }
};